import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { logError } from 'utils/logger';
import { EMPTY_VOUCHERS_BY_STATUS } from '../constants';
import { getMyVouchers } from '../service';

/**
 * Fetches and manages voucher requests for the logged-in employee.
 *
 * @param {string|number} employeeId
 * @returns {{
 *   vouchersByStatus: { pending: Array, closed: Array },
 *   loading: boolean,
 *   refresh: Function
 * }}
 */
export function useMyVouchers(employeeId) {
  const [vouchersByStatus, setVouchersByStatus] = useState(EMPTY_VOUCHERS_BY_STATUS);
  const [loading, setLoading] = useState(false);

  const fetchVouchers = useCallback(async () => {
    if (!employeeId) return;
    setLoading(true);
    try {
      const data = await getMyVouchers(employeeId);
      setVouchersByStatus(data);
    } catch (err) {
      toast.error(
        logError({
          message: 'Failed to fetch user vouchers',
          error: err,
          code: 'MY_VOUCHERS_FETCH_FAILED',
        }),
      );
    } finally {
      setLoading(false);
    }
  }, [employeeId]);

  useEffect(() => {
    fetchVouchers();
  }, [fetchVouchers]);

  return { vouchersByStatus, loading, refresh: fetchVouchers };
}
